import React from 'react';
import { FeatureTourOverlay } from '../common/FeatureTour';
import { Popover } from './Popover';
import { Portal } from '@klarna/mp-ui';
export default function PopOverWithHighlight({ children, showPopOver, popOverOnClose, componentRef, padding, position, radius }) {
    return (React.createElement(Portal, null,
        showPopOver && (React.createElement(FeatureTourOverlay, { componentRef: componentRef, onClick: popOverOnClose, padding: padding, radius: radius })),
        showPopOver && (React.createElement(Popover, { componentRef: componentRef, onClose: popOverOnClose, padding: padding, position: position }, children))));
}
